module.exports = __webpack_public_path__ + "img/TruthGPT-to-USD-price-chart.abde3c9b.webp";